module.exports = function(bh) {
    bh.match('shopping-basket', function(ctx, json) {
        ctx.tag('a').attrs({
            'data-toggle': 'open-hover',
            'data-target': '#BASKET_SMALL_001',
            'href': '/personal/cart',
        });
    });
};
